import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MaterialModule } from '../../material/material.module';
import { CustomDropdownModule } from '../custom-dropdown/custom-dropdown.module';
import { NewPlanPopupComponent } from './new-plan-popup.component';



@NgModule({
  declarations: [NewPlanPopupComponent],
  imports: [
    CommonModule,
     MaterialModule,
        CustomDropdownModule,
        MatIconModule,
        FormsModule,
       CommonModule,
    ReactiveFormsModule,
    FormsModule
       
  ],
   exports: [
      NewPlanPopupComponent,
  
      
  
    ]
})
export class NewPlanPopupModule { }
